import getDefaultShortenEventScope from './getDefaultShortenEventScope';
import { ShortenEventScopeType } from '../shortenEventScopeTypeConstants';

/**
 * Gets whether the event should start late or not
 */
export default function getDefaultShouldShortenEventDurationStartLate(): boolean {
    return getDefaultShortenEventScope() === ShortenEventScopeType.StartLate;
}
